export default "__VITE_ASSET__DAGXMyHx__"